import { useRouteQuery } from '@vueuse/router'
import { z } from 'zod'

export default (name: string, defaultValue?: boolean) => useRouteQuery(name, String(defaultValue ?? false), {
  transform: val => z.string().nullish().transform(val => val === 'true').parse(String(val)),
})
